<script setup lang="ts">
interface Props {
  lastSubmittedAt?: string | null
  completedAt?: string | null
}

const props = defineProps<Props>()

const { t, d } = useI18n()

interface Info {
  label: string
  value: string
  isBold: boolean
}

interface FormatInfoParams {
  labelKey: string
  date?: string | null
  fallbackKey: string
  boldIfExists?: boolean
}

function formatInfo({
  labelKey,
  date,
  fallbackKey,
  boldIfExists = true,
}: FormatInfoParams): Info {
  const hasValue = !!date
  return {
    label: t(labelKey),
    value: hasValue ? d(date, 'short') : t(fallbackKey),
    isBold: boldIfExists && hasValue,
  }
}

const sentInfo = computed(() =>
  formatInfo({
    labelKey: 'customer.biometry.date.last_submitted_at',
    date: props.lastSubmittedAt,
    fallbackKey: 'customer.biometry.date.not_started',
  }),
)

const completedInfo = computed(() => {
  if (!props.lastSubmittedAt) {
    return formatInfo({
      labelKey: 'customer.biometry.date.completed_at',
      fallbackKey: 'customer.biometry.date.not_started',
      boldIfExists: false,
    })
  }

  return formatInfo({
    labelKey: 'customer.biometry.date.completed_at',
    date: props.completedAt,
    fallbackKey: 'customer.biometry.date.in_progress',
  })
})
</script>

<template>
  <div class="flex flex-col gap-1 fonts-body-small-regular text-brand-primary-pure">
    <span>
      {{ sentInfo.label }}
      <span :class="{ 'fonts-body-small-bold': sentInfo.isBold }" data-testid="last-submitted-at-value">{{ sentInfo.value }}</span>
    </span>
    <span>
      {{ completedInfo.label }}
      <span :class="{ 'fonts-body-small-bold': completedInfo.isBold }" data-testid="completed-at-value">{{ completedInfo.value }}</span>
    </span>
  </div>
</template>
